module.exports = __webpack_public_path__ + "img/mk-历史@2x.b9bca326.png";